export default __webpack_public_path__ + "static/media/SourceSansPro-Semibold.65e949bf.ttf";